<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Col, Row } from "sveltestrap";
  import {
    Knowledgeaticlesbycategory,
    href,
  } from "../../../../utils/Constant/Constant";
  import { browserarticlesData } from "../../../../Data/Miscellaneous/KnowledgeBase";
  import Link from "svelte-link";
</script>

<Col sm="12">
  <div class="header-faq">
    <h5 class="mb-0">{Knowledgeaticlesbycategory}</h5>
  </div>
  <Row class="browse">
    {#each browserarticlesData as allItem}
      <Col xl="4" md="6" class="xl-50">
        <div class="browse-articles">
          <h6>
            <span>
              <FeatherIcon icon="archive" />
            </span>{allItem.title}
          </h6>
          <ul>
            {#each allItem.subdata as subItem}
              <li>
                <Link {href}>
                  <h5>
                    <FeatherIcon icon={subItem.icon} />
                    {subItem.paragraph}
                  </h5>
                </Link>
              </li>
            {/each}
          </ul>
        </div>
      </Col>
    {/each}
  </Row>
</Col>
